import { useCallback, useState } from "react";
import { api } from "src/shared/setup/API/api";

/** Resposta completa da API; na UI usamos totais (mensalidade, vidas, contratos). */
export interface IProducaoProdutorResponse {
  produtor: {
    id: string;
    nome: string;
    funcao_produtor: "CORRETOR" | "SUPERVISOR" | "GERENTE";
  };
  total_mensalidade_value: number;
  total_vidas: number;
  total_contratos: number;
}

type ProducaoTotais = Pick<IProducaoProdutorResponse, "total_mensalidade_value" | "total_vidas" | "total_contratos">;

const num = (v: unknown) => {
  const x = Number(v);
  return Number.isNaN(x) ? 0 : x;
};

const normalizePayload = (raw: unknown): ProducaoTotais | null => {
  if (!raw || typeof raw !== "object") return null;
  const obj = raw as Record<string, unknown>;
  const inner =
    obj.data && typeof obj.data === "object" ? (obj.data as Record<string, unknown>) : obj;

  return {
    total_mensalidade_value: num(inner.total_mensalidade_value),
    total_vidas: num(inner.total_vidas),
    total_contratos: num(inner.total_contratos),
  };
};

export const useProducerProducaoProdutor = () => {
  const [totalMensalidadeValue, setTotalMensalidadeValue] = useState<number>(0);
  const [totalVidas, setTotalVidas] = useState<number>(0);
  const [loadingProducao, setLoadingProducao] = useState(false);
  const [totalContratos, setTotalContratos] = useState<number>(0);

  const handleGetProducaoProdutor = useCallback(async (produtorId: string) => {
    if (!produtorId) return;

    setLoadingProducao(true);
    await api
      .get<unknown>(`metrics/producao-produtor/${produtorId}`)
      .then(({ data }) => {
        const parsed = normalizePayload(data);
        if (parsed) {
          setTotalMensalidadeValue(parsed.total_mensalidade_value);
          setTotalVidas(parsed.total_vidas);
          setTotalContratos(parsed.total_contratos);
        } else {
          setTotalMensalidadeValue(0);
          setTotalVidas(0);
          setTotalContratos(0);
        }
      })
      .catch(() => {
        setTotalMensalidadeValue(0);
        setTotalVidas(0);
        setTotalContratos(0);
      })
      .finally(() => setLoadingProducao(false));
  }, []);

  return {
    totalMensalidadeValue,
    totalVidas,
    totalContratos,
    loadingProducao,
    handleGetProducaoProdutor,
  };
};
